import React, { ReactNode } from 'react';

import { ContentWrapper, TitleWrapper, Wrapper } from './style';

type Props = {
  title: string;
  content: ReactNode;
  icon: ReactNode;
};

const InfoCard = ({ title, content, icon }: Props): JSX.Element => {
  return (
    <Wrapper>
      {icon}
      <TitleWrapper>{title}</TitleWrapper>
      <ContentWrapper>{content}</ContentWrapper>
    </Wrapper>
  );
};

export default InfoCard;
